import React from 'react';
import LabChooseGeneric from "../shared/components/generic/lab-choose/lab-choose-generic";
import LabCardGeneric from "../shared/components/generic/lab-card/lab-card-generic";
import MESSAGES from "../shared/constants/messages";

const MidiaLabsLabChoose = ({ onSelectLab, userLabs }) => {
	return (
		<LabChooseGeneric
			onSelectLab={ onSelectLab }
			title={ MESSAGES.MIDIA_LABS_CHOOSE_TITLE }
			subtitle={ MESSAGES.MIDIA_LABS_CHOOSE_SUBTITLE }
			subtitle2=""
			CardComponent={ LabCardGeneric }
			showPreferidos={ true }
			emptyMessage={ MESSAGES.MIDIA_LABS_NO_LABS }
			labsList={ userLabs }
			useComplexProps={ false }
			showMinhaOticaLink={ true }
		/>
	);
};

export default MidiaLabsLabChoose;